import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ onLogout }) {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            Plazza ERP
          </Link>
        </div>
        
        {/* Mobile hamburger menu */}
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Product Search
          </Link>
          <Link 
            to="/catalogue" 
            className={`navbar-link ${location.pathname === '/catalogue' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Catalogue Search
          </Link>
          {/* <Link 
            to="/elasticsearch" 
            className={`navbar-link ${location.pathname === '/elasticsearch' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Elasticsearch Search
          </Link> */}
          <Link 
            to="/inventory" 
            className={`navbar-link ${location.pathname === '/inventory' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Inventory Management
          </Link>
          <button 
            className="navbar-link logout-btn"
            onClick={() => {
              onLogout();
              closeMenu();
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 